var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',[_c('b-datepicker',{attrs:{"icon":"calendar","placeholder":_vm.label,"month-names":_vm.monthNames,"day-names":_vm.dayNames,"type":_vm.type,"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }